export interface UserPermissions {
    permissions: string[];
}

export type AppModule =
    | "cms"           // OTT CMS
    | "live"          // Live CMS
    | "analytics"     // Analytics Dashboard
    | "chopper"       // Video editing (requires cms access)
    | "optimus"       // Content optimization (requires cms access)
    | "adManager"     // Ad Manager (requires cms access)
    | "adminConsole"  // Admin Console (requires *.*.*.*)
    | "fastcms"       // FAST CMS                          - fast
    | "cmsAnalytics"  // CMS Analytics                     - analytics 
    | "billing"       // Billing Dashboard          
    | "compassAI"     // Compass AI
    | "developerConsole"; // Developer Console               - public

/**
 * Check if user has wildcard access (*.*.*.*)
 */
export const hasWildcardAccess = (permissions: string[]): boolean => {
    return permissions.some(perm => perm === "*.*.*.*");
};

/**
 * Check if user has access to a specific module
 * @param permissions - Array of permission strings
 * @param module - Module name to check (cms, cleo, analytics)
 */
export const hasModuleAccess = (
    permissions: string[],
    module: string
): boolean => {
    if (hasWildcardAccess(permissions)) {
        return true;
    }

    // Check if any permission contains the module or has wildcard in module position
    return permissions.some(perm => {
        const parts = perm.split('.');
        if (parts.length >= 3) {
            // Check for exact module match OR wildcard in module position
            return parts[2] === module || parts[2] === '*';
        }
        return false;
    });
};

